export default class Video {
	constructor(root) {
		this.root = root;
		this.iframe = root?.querySelector('iframe');
		this.playPauseBtn = root?.querySelector('.play-pause');
		this.provider = this.iframe?.getAttribute('data-provider');
		this.isPlaying = this.iframe?.getAttribute('data-autoplay') === 'true';
		this.isPlaying ? this.usePauseIcon() : this.usePlayIcon();

		this.playPauseBtn?.addEventListener('click', () => {
			this.isPlaying ? this.pause() : this.play();
			this.isPlaying = !this.isPlaying;
		});
	}

	usePauseIcon() {
		const icon = this.playPauseBtn?.querySelector('.play-pause-icon');
		icon?.classList.remove('fa-play');
		icon?.classList.add('fa-pause');
	}

	usePlayIcon() {
		const icon = this.playPauseBtn?.querySelector('.play-pause-icon');
		icon?.classList.remove('fa-pause');
		icon?.classList.add('fa-play');
	}

	play() {
		this.usePauseIcon();

		switch (this.provider) {
			case 'vimeo':
				this.iframe?.contentWindow.postMessage(
					{
						method: 'play',
					},
					'*'
				);
			case 'youtube':
				this.iframe?.contentWindow.postMessage(
					JSON.stringify({
						event: 'command',
						func: 'playVideo',
						args: '',
					}),
					'*'
				);
		}
	}

	pause() {
		this.usePlayIcon();

		switch (this.provider) {
			case 'vimeo':
				this.iframe?.contentWindow.postMessage(
					{
						method: 'pause',
					},
					'*'
				);
			case 'youtube':
				this.iframe?.contentWindow.postMessage(
					JSON.stringify({
						event: 'command',
						func: 'pauseVideo',
						args: '',
					}),
					'*'
				);
		}
	}
}
